import { forwardRef } from 'react';
import { theme } from '@frontend/theme';
import { PopoverMenuItem, Text } from '@frontend/design-system';
import { formatPhoneNumber } from '../../utils/formatting-utils';

type Props = {
  to: string;
  onClick: () => void;
  trackingId?: string;
  active?: boolean;
};
export const AutocompleteRawCall = forwardRef<HTMLLIElement, Props>(({ to, onClick, active }: Props, ref) => {
  return (
    <li
      ref={ref}
      className='raw'
      key={to}
      tabIndex={0}
      css={{
        background: active ? theme.colors.neutral70 : 'transparent',
      }}
    >
      <PopoverMenuItem
        css={{
          background: 'transparent',
        }}
        className='list-item'
        onClick={onClick}
        active={active}
      >
        <Text color='white' weight='semibold'>
          {formatPhoneNumber(to ?? '')}
        </Text>
      </PopoverMenuItem>
    </li>
  );
});

AutocompleteRawCall.displayName = 'AutocompleteRawCall';
